export function getValuesForField(filters, field, allValues) {
  const found = filters.find(filter => filter.field === field);
  return found ? found.values : allValues;
}

export function replaceValuesForField(filters, field, newValues, allValues) {
  const others = filters.filter(filter => filter.field !== field);
  if (!newValues.length || newValues.length === allValues.length) {
    return others;
  }
  return [...others, { field, values: newValues }];
}
